var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualifiedCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_2508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50065 11.9166C9.49219 11.9166 11.9173 9.49146 11.9173 6.49992C11.9173 3.50838 9.49219 1.08325 6.50065 1.08325C3.50911 1.08325 1.08398 3.50838 1.08398 6.49992C1.08398 9.49146 3.50911 11.9166 6.50065 11.9166Z",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 6.50008L5.95833 7.58341L8.125 5.41675",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_2508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifiedCheckmark);
export default __webpack_public_path__ + "static/media/qualified-checkmark.1bdec25224324bc267569a7a9ec20bae.svg";
export { ForwardRef as ReactComponent };